import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PeticaoArea } from '@app/models/peticao-area.model';

import { PeticaoAreaService } from '@app/services/peticao-area.service';

@Component({
  selector: 'app-peticao-areas-form',
  templateUrl: './peticao-areas-form.component.html'
})
export class PeticaoAreasFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  peticaoArea: PeticaoArea = new PeticaoArea();
  aguardandoSolicitacao = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private peticaoAreaService: PeticaoAreaService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Área' : 'Novo Área';

      if (!id) {
        return;
      }

      this.peticaoAreaService.obterPorId(id).toPromise().then(
        data => this.peticaoArea = data,
        () => this.router.navigate(['./peticao/areas']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.peticaoAreaService.gravar(this.peticaoArea).toPromise().then(
      () => this.router.navigate(['./peticao/areas']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
